import AnalyticsEngineBase from "./../analyticsenginebase";
import { insertGAScriptTag } from "./../../utilities/DOMUtils";
import * as eventNames from "./../analyticsevents";

export default class AnalyticsEngineGA extends AnalyticsEngineBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);
    this._options = options;
    let isEnabled = true;
    if (analyticsManager.cmpManager) {
      isEnabled = analyticsManager.cmpManager.isGATrackingEnabled();
      analyticsManager.cmpManager.on("userConsent:changed", () => {
        this.setTracking(analyticsManager.cmpManager.isGATrackingEnabled());
      });
    }
    insertGAScriptTag(options.gaTag, isEnabled);
    this._subscribeToEvents();
  }

  _subscribeToEvents() {
    //events
    this._analyticsManagerBase.on(eventNames.CLICKED_MAIN_HOME, (data) => {
      this._eventClickMain(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_READ_HOME, (data) => {
      this._eventClickMain(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_ARCHIVE_HOME, (data) => {
      this._eventClickArchive(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_PROMOSPOT_HOME, (data) => {
      this._eventClickPromospot(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_SPECIALS_HOME, (data) => {
      this._eventClickExtra(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_HOME_SIDEBAR, (data) => {
      this._eventClickedHome(data);
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_RECENTLY_SIDEBAR,
      (data) => {
        this._eventClickSidebarRecently(data);
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_SUPPLEMENTS_SIDEBAR,
      (data) => {
        this._eventClickSidebarSupplement(data);
      }
    );
    this._analyticsManagerBase.on(eventNames.CLICKED_EXTRAS_SIDEBAR, (data) => {
      this._eventClickSidebarExtra(data);
    });
    this._analyticsManagerBase.on(
      eventNames.OPENED_PUBLICATION_READER,
      (data) => {
        const {
          eventData: {
            bundle: { publication },
          },
        } = data;
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Open",
          `Open${publication.type}In${publication.format}`
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.SWIPE_PAGE_FORWARD_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Swipe",
          "MoveToNextPage"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.SWIPE_PAGE_BACKWARD_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Swipe",
          "MoveToPreviousPage"
        );
      }
    );
    this._analyticsManagerBase.on(eventNames.ZOOM_PAGE_IN_READER, () => {
      this._sendEventToGA("ReplicaReader", "Pinch", "ZoomIn");
    });
    this._analyticsManagerBase.on(eventNames.ZOOM_PAGE_OUT_READER, () => {
      this._sendEventToGA("ReplicaReader", "Pinch", "ZoomOut");
    });
    this._analyticsManagerBase.on(
      eventNames.ZOOM_PAGE_IN_READER_ON_DESKTOP,
      () => {
        this._sendEventToGA("ReplicaReader", "Click", "ZoomIn");
      }
    );
    this._analyticsManagerBase.on(
      eventNames.ZOOM_PAGE_OUT_READER_ON_DESKTOP,
      () => {
        this._sendEventToGA("ReplicaReader", "Click", "ZoomOut");
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_PAGE_ARTICLE_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "ClickToOpenArticleLightbox"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_CATEGORY_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "SelectPageCategory"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_BOTTOM_NAVIGATION_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "ClickOnBottomNavigation"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_SUPPLEMENT_SUPP_SCREEN,
      (data) => {
        this._eventClickSupplementSupplementScreen(data);
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_SUPPLEMENT_TOPNAV_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "ClickOnSupplement"
        );
      }
    );
    this._analyticsManagerBase.on(eventNames.OPENED_ALB, (data) => {
      this._sendEventToGA(
        this._getReaderCategoryByPublicationType(data),
        "Open",
        "OpenArticleLightbox"
      );
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_DOUBLEPAGE_TOGGLE_SETTINGS,
      (data) => {
        this._eventToggleLandscapeToggleDouble(data);
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_SINGLEPAGE_TOGGLE_SETTINGS,
      (data) => {
        this._eventToggleLandscapeToggleSingle(data);
      }
    );
    this._analyticsManagerBase.on(eventNames.SWIPED_FORWARD_ALB, (data) => {
      this._eventSwipeForwardAlb(data);
    });
    this._analyticsManagerBase.on(eventNames.SWIPED_BACKWARD_ALB, (data) => {
      this._eventSwipeBackwardAlb(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_FONT_ALB, (data) => {
      this._eventClickFont(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_NEXT_ALB, (data) => {
      this._eventClickNextAlb(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_PREV_ALB, (data) => {
      this._eventClickBackAlb(data);
    });
    this._analyticsManagerBase.on(eventNames.SWIPED_FORWARD_GALLERY, (data) => {
      this._eventSwipeForwardGallery(data);
    });
    this._analyticsManagerBase.on(
      eventNames.SWIPED_BACKWARD_GALLERY,
      (data) => {
        this._eventSwipeBackwardGallery(data);
      }
    );
    this._analyticsManagerBase.on(eventNames.ZOOM_IN_IMAGE_GALLERY, (data) => {
      this._eventPinchZoomInGallery(data);
    });
    this._analyticsManagerBase.on(eventNames.ZOOM_OUT_IMAGE_GALLERY, (data) => {
      this._eventPinchZoomOutGallery(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_SIGNIN_TOPNAV, (data) => {
      this._eventClickSignInHome(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_SIGNOUT_TOPNAV, (data) => {
      this._eventClickSignOutHome(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_HAMBURGER_HOME, (data) => {
      this._eventClickHamburgerHome(data);
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_HAMBURGER_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "ClickHamburger"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_REGION_REGIONSELECT,
      (data) => {
        this._eventClickSelectRegion(data);
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_FORGOTPW_PAYWALL,
      (data) => {
        this._eventClickForgotPassword(data);
      }
    );
    this._analyticsManagerBase.on(eventNames.REACHED_REDIRECT_LIMIT, (data) => {
      this._eventReachedRedirectionLimit(data);
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_SETTINGS_SIDEBAR,
      (data) => {
        this._eventClickSettings(data);
      }
    );
    this._analyticsManagerBase.on(eventNames.CLICKED_SETTINGS, (data) => {
      this._eventClickDesktopSettings(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_HELP, (data) => {
      this._eventClickTopNavHelp(data);
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_REGIONSELECT_SETTINGS,
      (data) => {
        this._eventClickRegionSection(data);
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_ACCOUNT_SETTINGS,
      (data) => {
        this._eventClickAccountSection(data);
      }
    );
    this._analyticsManagerBase.on(eventNames.CLICKED_HELP_SETTINGS, (data) => {
      this._eventClickHelpSection(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_ABOUT_SETTINGS, (data) => {
      this._eventClickAboutSection(data);
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_LOGOUT_SETTINGS,
      (data) => {
        this._eventClickSignOutSettings(data);
      }
    );
    this._analyticsManagerBase.on(eventNames.CLICKED_FACEBOOK_SHARE, (data) => {
      this._eventShareFacebook(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_WHATSAPP_SHARE, (data) => {
      this._eventShareWhatsApp(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_GOOGLE_SHARE, (data) => {
      this._eventShareGoogle(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_TWITTER_SHARE, (data) => {
      this._eventShareTwitter(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_MAIL_SHARE, (data) => {
      this._eventShareMail(data);
    });
    this._analyticsManagerBase.on(
      eventNames.SWIPED_FORWARD_IMAGEVIEWER,
      (data) => {
        this._eventSwipeForwardImageAlb(data);
      }
    );
    this._analyticsManagerBase.on(
      eventNames.SWIPED_BACKWARD_IMAGEVIEWER,
      (data) => {
        this._eventSwipeBackwardImageAlb(data);
      }
    );
    this._analyticsManagerBase.on(eventNames.CLICKED_NEWSSTAND, (data) => {
      this._eventClickNewsStand(data);
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_SUPPLEMENT_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "ClickOnSupplement"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_FULLSCREEN_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "ClickOnFullScreen"
        );
      }
    );
    this._analyticsManagerBase.on(eventNames.CLICKED_PRINT_TEXT_ALB, (data) => {
      this._eventClickPrintArticleText(data);
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_PRINT_IMAGE_ALB,
      (data) => {
        this._eventClickPrintArticleImage(data);
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_PAGE_NEXT_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "NavigateBetweenPages"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_PAGE_PREV_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "NavigateBetweenPages"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_PAGE_NEXT_TOP_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "NavigateBetweenPages"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_PAGE_NEXT_BOT_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "NavigateBetweenPages"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_PAGE_PREV_TOP_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "NavigateBetweenPages"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_PAGE_PREV_BOT_READER,
      (data) => {
        this._sendEventToGA(
          this._getReaderCategoryByPublicationType(data),
          "Click",
          "NavigateBetweenPages"
        );
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_FULLPDFDOWNLOAD_READER,
      (data) => {
        this._eventClickFullDownload(data);
      }
    );
    this._analyticsManagerBase.on(eventNames.CLICKED_NEXT_GALLERY, (data) => {
      this._eventClickNextGallery(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_PREV_GALLERY, (data) => {
      this._eventClickPrevGallery(data);
    });
    this._analyticsManagerBase.on(eventNames.CLICKED_PRINT_ALB, (data) => {
      this._eventClickPrintAlb(data);
    });
    this._analyticsManagerBase.on(eventNames.OPENED_NEXTEGEN_READER, () => {
      this._sendEventToGA("NextgenReader", "Open", "OpenNextgenReader");
    });
    this._analyticsManagerBase.on(eventNames.ACCESSED_SOCIALSHARING, (data) => {
      this._sendEventToGA(
        this._getReaderCategoryByPublicationType(data),
        "Entry",
        "SocialSharing"
      );
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_SINGLEPAGEPDFDOWNLOAD_READER,
      (data) => {
        this._eventClickSinglePageDownload(data);
      }
    );

    //page views
    this._analyticsManagerBase.on(eventNames.VIEW_PAGE, (data) => {
      this._reader(data);
    });
    this._analyticsManagerBase.on(
      eventNames.VIEW_PAGE_IN_BACKGROUND,
      (data) => {
        this._reader(data, true);
      }
    );
    this._analyticsManagerBase.on(eventNames.VIEW_ARTICLE_ALB, (data) => {
      this._alb(data);
    });
    this._analyticsManagerBase.on(
      eventNames.VIEW_ARTICLE_ALB_NEXTGEN,
      (data) => {
        this._albNextgen(data);
      }
    );
    this._analyticsManagerBase.on(eventNames.OPENED_GALLERY_ALB, (data) => {
      this._gallery(data);
      this._sendEventToGA(
        this._getReaderCategoryByPublicationType(data),
        "Open",
        "OpenImageGallery"
      );
    });
    this._analyticsManagerBase.on(eventNames.VIEW_IMAGE_GALLERY, (data) => {
      this._gallery(data);
    });
    this._analyticsManagerBase.on(eventNames.OPENED_HOME, (data) => {
      this._home(data);
    });
    this._analyticsManagerBase.on(eventNames.OPENED_PAYWALL, (data) => {
      this._paywall(data);
    });
    this._analyticsManagerBase.on(eventNames.VIEW_PAGE_NEXGEN, (data) => {
      this._nextgenReader(data);
    });
    this._analyticsManagerBase.on(
      eventNames.CLICKED_NEXTGEN_READING_MODE_HOME,
      () => {
        this._eventChangeReadingMode("Home");
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_REPLICA_READING_MODE_HOME,
      () => {
        this._eventChangeReadingMode("Home");
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_NEXTGEN_READING_MODE_SIDEBAR,
      () => {
        this._eventChangeReadingMode("Sidebar");
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_REPLICA_READING_MODE_SIDEBAR,
      () => {
        this._eventChangeReadingMode("Sidebar");
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_NEXTGEN_READING_MODE_READER,
      () => {
        this._sendEventToGA("ReplicaReader", "Click", "ChangeReadingMode");
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_REPLICA_READING_MODE_READER,
      () => {
        this._sendEventToGA("NextgenReader", "Click", "ChangeReadingMode");
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_NEXTGEN_READING_MODE_SETTINGS,
      () => {
        this._eventChangeReadingMode("Settings");
      }
    );
    this._analyticsManagerBase.on(
      eventNames.CLICKED_REPLICA_READING_MODE_SETTINGS,
      () => {
        this._eventChangeReadingMode("Settings");
      }
    );
    this._analyticsManagerBase.on(
      eventNames.OPENED_SUPPLEMENT_SCREEN_READER,
      (data) => {
        this._supplementsOverview(data);
      }
    );

    this._analyticsManagerBase.on(eventNames.CLICKED_PRINT_READER, () => {
      this._eventClickPrintReader();
    });

    this._analyticsManagerBase.on(eventNames.ADJUSTED_BOX_CROPPING, () => {
      this._eventAdjustCroppingBox();
    });

    this._analyticsManagerBase.on(eventNames.CLICKED_PRINT_CROPPING, () => {
      this._eventClickPrintCropping();
    });

    this._analyticsManagerBase.on(
      eventNames.CLICKED_TOP_NAV_SINGLE_PAGE_MODE,
      () => {
        this._eventClickDesktopTopNavSinglePageMode();
      }
    );

    this._analyticsManagerBase.on(
      eventNames.CLICKED_TOP_NAV_DOUBLE_PAGE_MODE,
      () => {
        this._eventClickDesktopTopNavDoublePageMode();
      }
    );
    this._analyticsManagerBase.on(eventNames.PAYWALL_LOGIN_AFTER_SHARE, () => {
      this._sendEventToGA("Paywall", "Login", "LoginAfterSharing");
    });

    this._subscribeToExtraEvents();
  }
  _subscribeToExtraEvents() {
    //empty method, client can overwrite
  }

  //click events
  _eventClickMain() {
    this._sendEventToGA("Home", "Click", "ClickOnMain");
  }
  _eventClickArchive() {
    this._sendEventToGA("Home", "Click", "ClickOnMain");
  }
  _eventClickPromospot() {
    this._sendEventToGA("Home", "Click", "ClickOnPublicationInPromospot");
  }
  _eventClickExtra() {
    this._sendEventToGA("Home", "Click", "ClickOnExtra");
  }
  _eventClickDesktopSettings() {
    this._sendEventToGA("", "Click", "ClickSettings");
  }
  _eventClickTopNavHelp(data) {
    let _category;
    if (!data.isReader) {
      _category = "Home";
    } else {
      if (this._isReplica(data)) {
        _category = "ReplicaReader";
      } else {
        _category = "NextgenReader";
      }
    }
    this._sendEventToGA(_category, "Click", "ClickOnHelp");
  }
  _eventClickNewsStand() {
    this._sendEventToGA("Home", "Click", "ClickOnNewsStand");
  }
  _eventClickedHome() {
    this._sendEventToGA("Sidebar", "Click", "GoHome");
  }
  _eventClickSidebarRecently() {
    this._sendEventToGA("Sidebar", "Click", "ClickOnMain");
  }
  _eventClickSidebarSupplement() {
    this._sendEventToGA("Sidebar", "Click", "ClickOnSupplement");
  }
  _eventClickSidebarExtra() {
    this._sendEventToGA("Sidebar", "Click", "ClickOnExtra");
  }
  _eventClickSupplementSupplementScreen() {
    this._sendEventToGA("SupplementScreen", "Click", "ClickOnSupplement");
  }
  _eventClickFullDownload() {
    this._sendEventToGA("Reader", "Click", "StartFullPdfDownload");
  }
  _eventSwipeForwardAlb() {
    this._sendEventToGA(
      "ArticleLightbox",
      "Swipe",
      "MoveToNextArticleLightbox"
    );
  }
  _eventSwipeBackwardAlb() {
    this._sendEventToGA(
      "ArticleLightbox",
      "Swipe",
      "MoveToPreviousArticleLightbox"
    );
  }
  _eventClickFont() {
    this._sendEventToGA("ArticleLightbox", "Click", "ChangeFontSize");
  }
  _eventClickNextAlb() {
    this._sendEventToGA(
      "ArticleLightbox",
      "Click",
      "MoveToNextArticleLightbox"
    );
  }
  _eventClickBackAlb() {
    this._sendEventToGA(
      "ArticleLightbox",
      "Click",
      "MoveToPreviousArticleLightbox"
    );
  }
  _eventSwipeForwardGallery() {
    this._sendEventToGA("ImageGallery", "Swipe", "MoveToNextImage");
  }
  _eventSwipeBackwardGallery() {
    this._sendEventToGA("ImageGallery", "Swipe", "MoveToPreviousImage");
  }
  _eventPinchZoomInGallery() {
    this._sendEventToGA("ImageGallery", "Pinch", "ZoomIn");
  }
  _eventPinchZoomOutGallery() {
    this._sendEventToGA("ImageGallery", "Pinch", "ZoomOut");
  }
  _eventClickNextGallery() {
    this._sendEventToGA("ImageGallery", "Click", "MoveToNextImage");
  }
  _eventClickPrevGallery() {
    this._sendEventToGA("ImageGallery", "Click", "MoveToPreviousImage");
  }
  _eventClickSignInHome() {
    this._sendEventToGA("Home", "Click", "ClickSignIn");
  }
  _eventClickSignOutHome() {
    this._sendEventToGA("Home", "Click", "ClickSignOut");
  }
  _eventClickHamburgerHome() {
    this._sendEventToGA("Home", "Click", "ClickHamburger");
  }
  _eventClickSelectRegion() {
    this._sendEventToGA("-", "Click", "SelectRegion");
  }
  _eventClickForgotPassword() {
    this._sendEventToGA("Paywall", "Click", "ClickForgotPassword");
  }
  _eventReachedRedirectionLimit() {
    this._sendEventToGA("-", "Flow", "ReachedRedirectionsLimit");
  }
  _eventClickSettings() {
    this._sendEventToGA("Sidebar", "Click", "ClickSettings");
  }
  _eventClickRegionSection() {
    this._sendEventToGA("Settings", "Click", "ClickOnRegionsSection");
  }
  _eventClickAccountSection() {
    this._sendEventToGA("Settings", "Click", "ClickOnAccountSection");
  }
  _eventClickHelpSection() {
    this._sendEventToGA("Settings", "Click", "ClickOnHelpSection");
  }
  _eventClickAboutSection() {
    this._sendEventToGA("Settings", "Click", "ClickOnAboutSection");
  }
  _eventClickSignOutSettings() {
    this._sendEventToGA("Settings", "Click", "ClickSignOut");
  }
  _eventShareFacebook(data) {
    const category = this._isReplica(data)
      ? "ArticleLightbox"
      : "NextgenReader";
    this._sendEventToGA(category, "Share", "ShareOnFacebook");
  }
  _eventShareWhatsApp(data) {
    const category = this._isReplica(data)
      ? "ArticleLightbox"
      : "NextgenReader";
    this._sendEventToGA(category, "Share", "ShareOnWhatsApp");
  }
  _eventShareGoogle(data) {
    const category = this._isReplica(data)
      ? "ArticleLightbox"
      : "NextgenReader";
    this._sendEventToGA(category, "Share", "ShareOnGoogle");
  }
  _eventShareTwitter(data) {
    const category = this._isReplica(data)
      ? "ArticleLightbox"
      : "NextgenReader";
    this._sendEventToGA(category, "Share", "ShareOnTwitter");
  }
  _eventShareMail(data) {
    const category = this._isReplica(data)
      ? "ArticleLightbox"
      : "NextgenReader";
    this._sendEventToGA(category, "Share", "ShareOnMail");
  }
  _eventSwipeForwardImageAlb() {
    this._sendEventToGA("ArticleLightbox", "Swipe", "MoveToNextImage");
  }
  _eventSwipeBackwardImageAlb() {
    this._sendEventToGA("ArticleLightbox", "Swipe", "MoveToPreviousImage");
  }
  _eventClickPrintAlb() {
    this._sendEventToGA("ArticleLightbox", "Print", "PrintArticleLightbox");
  }
  _eventClickPrintArticleImage() {
    this._sendEventToGA(
      "ArticleLightbox",
      "Print",
      "PrintArticleLightboxImage"
    );
  }
  _eventClickPrintArticleText() {
    this._sendEventToGA("ArticleLightbox", "Print", "PrintArticleLightboxText");
  }
  _eventToggleLandscapeToggleDouble() {
    this._sendEventToGA("Settings", "Click", "ChangeToDoublePageDisplay");
  }
  _eventToggleLandscapeToggleSingle() {
    this._sendEventToGA("Settings", "Click", "ChangeToSinglePageDisplay");
  }

  _eventClickDesktopTopNavSinglePageMode() {
    this._sendEventToGA("ReplicaReader", "Click", "ClickOnSinglePageMode");
  }
  _eventClickDesktopTopNavDoublePageMode() {
    this._sendEventToGA("ReplicaReader", "Click", "ClickOnDoublePageMode");
  }

  _eventChangeReadingMode(category) {
    this._sendEventToGA(category, "Click", "ChangeReadingMode");
  }
  _eventClickSinglePageDownload() {
    this._sendEventToGA("Reader", "Click", "StartSinglePageDownload");
  }

  _eventClickPrintReader() {
    this._sendEventToGA("Reader", "Print", "PrintArticleLightboxText");
  }

  _eventClickPrintCropping() {
    this._sendEventToGA("Reader", "Print", "PrintCroppedPage");
  }

  _eventAdjustCroppingBox() {
    this._sendEventToGA("Reader", "Print", "AdjustCroppingBox");
  }

  _nextgenReader(data) {
    const basicPageStructure = this._createBasicPageStructure(data);

    if (data && data.eventData && data.eventData.bundle) {
      const page = data.eventData.bundle.publication.pages[0];

      if (page) {
        const articleReference = page.articles[0]
          ? page.articles[0].articleReference
          : "";
        const fullPageStructure = `${basicPageStructure}/${page.pageTemplate}/${articleReference}`;
        const jsonObject = this._createPageViewJson(
          this._options.titleNextgenReader,
          fullPageStructure
        );
        this._setPageViewPageTracker(fullPageStructure);
        this._sendPageViewToGA(jsonObject);
      }
    }
  }

  _reader(data, inBackground = false) {
    const pageStructure = this._createPagePageStructure(data);
    this._setPageViewPageTracker(pageStructure[0]);
    pageStructure.forEach((structure) => {
      const title = inBackground
        ? this._options.titleReplicaReaderInBackground
        : this._options.titleReplicaReader;
      const jsonObject = this._createPageViewJson(title, structure);
      jsonObject.mode = data.mode;
      this._sendPageViewToGA(jsonObject);
    });
  }
  _paywall() {
    const jsonObject = this._createPageViewJson(
      this._options.titlePayWall,
      "/"
    );
    this._setPageViewPageTracker("/");
    this._sendPageViewToGA(jsonObject);
  }
  _home() {
    const jsonObject = this._createPageViewJson(
      this._options.titleHome,
      "/index.html"
    );
    this._setPageViewPageTracker("/index.html");
    this._sendPageViewToGA(jsonObject);
  }
  _alb(data) {
    const pageStructure = this._createArticlePageStructure(data);
    const jsonObject = this._createPageViewJson(
      this._options.titleArticleLightBox,
      pageStructure
    );
    this._setPageViewPageTracker(pageStructure);
    this._sendPageViewToGA(jsonObject);
  }
  _albNextgen(data) {
    const basicPageStructure = this._createBasicPageStructure(data);
    const {
      eventData: {
        bundle: {
          publication: { pages },
        },
      },
    } = data;
    const pageStructure = `${basicPageStructure}/${pages[0].pageReference}/${data.articleReference}`;
    const jsonObject = this._createPageViewJson(
      this._options.titleArticleLightBox,
      pageStructure
    );
    this._setPageViewPageTracker(pageStructure);
    this._sendPageViewToGA(jsonObject);
  }
  _gallery(data) {
    const pageStructure = this._createArticlePageStructure(data);
    this._setPageViewPageTracker(pageStructure);
    const jsonObject = this._createPageViewJson(
      this._options.titleGallery,
      pageStructure
    );
    this._sendPageViewToGA(jsonObject);
  }
  _supplementsOverview(data) {
    const pageStructure = this._createPagePageStructure(data);
    this._setPageViewPageTracker(pageStructure[0]);
    pageStructure.forEach((structure) => {
      const jsonObject = this._createPageViewJson(
        this._options.titleSupplementsOverview,
        structure
      );
      this._sendPageViewToGA(jsonObject);
    });
  }

  //helper functions

  _sendPageViewToGA(jsonObject) {
    if (!jsonObject || jsonObject === {}) {
      window.ga("send", "pageview");
    } else {
      window.ga("send", "pageview", jsonObject);
    }
  }

  _sendEventToGA(category, action, label, value) {
    if (value !== undefined) {
      window.ga("send", "event", category, action, label, value);
    } else {
      window.ga("send", "event", category, action, label);
    }
  }

  _createBasicPageStructure(data) {
    const {
      eventData: { bundle },
    } = data;
    return `${bundle.downloadToken}/${bundle.bundleDateTime}/${bundle.publication.format}`;
  }

  _createPagePageStructure(data) {
    const pageStructures = [];
    const basicPageStructure = this._createBasicPageStructure(data);
    if (data && data.eventData && data.eventData.bundle) {
      data.eventData.bundle.publication.pages.forEach((page) => {
        if (page) {
          const pageReference = page.pageReference || page.pagePosition;
          var fullPageStructure = `${basicPageStructure}/${pageReference}`;
          if (
            data.deviceContext &&
            data.deviceContext.appContext &&
            data.deviceContext.appContext.socialSharing
          ) {
            fullPageStructure = fullPageStructure + "/SocialSharing";
          }
          pageStructures.push(fullPageStructure);
        }
      });
    }
    return pageStructures;
  }

  _createArticlePageStructure(data) {
    const basicPageStructure = this._createBasicPageStructure(data);
    var result = `${basicPageStructure}/${data.eventData.bundle.publication.pages[0].pageReference}/${data.eventData.bundle.publication.pages[0].articles[0].articleReference}`;
    if (
      data.deviceContext &&
      data.deviceContext.appContext &&
      data.deviceContext.appContext.socialSharing
    ) {
      result = result + "/SocialSharing";
    }
    return result;
  }

  _createPageViewJson(title, pageStructure) {
    const jsonObject = {};
    jsonObject.title = title;
    if (pageStructure) {
      jsonObject.page = pageStructure;
    }
    return jsonObject;
  }

  _setPageViewPageTracker(pageStructure) {
    window.ga((tracker) => {
      // update the tracker if the page has changed
      if (pageStructure !== tracker.get("page")) {
        window.ga("set", "page", pageStructure);
      }
    });
  }

  _getReaderCategoryByPublicationType(data) {
    const {
      eventData: {
        bundle: { publication },
      },
    } = data;
    return `${publication.format}Reader`;
  }

  _isReplica(data) {
    return data.eventData.bundle.publication.format === "Replica";
  }

  setTracking(isTrackingEnable) {
    window[`ga-disable-${this._options.gaTag}`] = !isTrackingEnable;
  }
}



// WEBPACK FOOTER //
// ./src/common/analytics/engines/analyticsEngineGA.js